import { useIsOverflow } from '../../../../../ui/features/badge-management/hooks/useIsOverflow';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PrintIcon from '@mui/icons-material/Print';
import { Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useAccountBadgeActions } from '../../hooks/useAccountBadgeActions';
import { AccountBadgeDistributionLabel } from './AccountBadgeDistributionLabel';
export const badgeDistributionIconMap = {
    'not-printed': React.createElement(PrintIcon, { sx: { color: themeColors.accent.grey.base } }),
    processing: React.createElement(PrintIcon, { sx: { color: themeColors.accent.blue.base } }),
    printed: React.createElement(PrintIcon, { sx: { color: themeColors.accent.blue.base } }),
    distributed: React.createElement(HowToRegIcon, { htmlColor: themeColors.accent.green.base }),
};
export const AccountBadgeDistributionCell = ({ accountBadge, onActionSuccess }) => {
    const { t } = useBadgingTranslation();
    const distributionRef = React.useRef(null);
    const { status, statusReasonDescription, distributionStatusLastUpdatedAt } = accountBadge.columns;
    const distributionFieldText = React.useMemo(() => {
        return status === 'expired' ? t('badges.badgeDetails.accountBadgeTable.expiredDescription') : statusReasonDescription;
    }, [status, statusReasonDescription, t]);
    const isOverflow = useIsOverflow({
        ref: distributionRef,
        direction: 'vertical',
        extraDependency: distributionFieldText,
    });
    const distributionStatus = accountBadge.columns.distributionStatus;
    const icon = badgeDistributionIconMap[distributionStatus];
    const actions = useAccountBadgeActions({
        accountBadge,
        onActionSuccess,
    });
    return (React.createElement(TextCell, { sx: { maxWidth: 350 } }, status === 'valid' ? (React.createElement(Stack, { direction: 'column', gap: 1, alignItems: 'flex-start' },
        React.createElement(Stack, { direction: 'row', gap: 1, alignItems: 'center' },
            icon,
            React.createElement(Typography, { variant: 'body2', color: themeColors.text.main, sx: { wordBreak: 'break-word' } }, t(`badges.badgeDetails.distributionStatuses.${distributionStatus}`))),
        React.createElement(AccountBadgeDistributionLabel, { status: status, distributionStatus: distributionStatus, distributionStatusLastUpdatedAt: distributionStatusLastUpdatedAt, onDistributionStatusEdit: actions.handleAccountBadgeDistributionStatusChange }))) : (React.createElement(Tooltip, { title: isOverflow ? distributionFieldText : undefined },
        React.createElement(Typography, { variant: 'body2', ref: distributionRef, sx: {
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordBreak: 'break-word',
            } }, distributionFieldText)))));
};
